import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type { UserCapability, UserCapabilitiesResponse, UpdateUserCapabilityPayload } from '@/lib/types';

const USER_CAPABILITIES_API = '/api/v1/user-capabilities';

export function useUserCapabilities(userId?: number | null) {
  const filters = userId != null ? { user: userId } : {};
  return useQuery({
    queryKey: queryKeys.userCapabilities.list(filters),
    queryFn: async (): Promise<UserCapabilitiesResponse> => {
      const response = await apiClient.get<UserCapabilitiesResponse>(
        `${USER_CAPABILITIES_API}/`,
        { params: filters }
      );
      return response.data;
    },
    enabled: userId != null,
  });
}

export function useUpdateUserCapability() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: number;
      data: UpdateUserCapabilityPayload;
    }): Promise<UserCapability> => {
      const response = await apiClient.patch<UserCapability>(
        `${USER_CAPABILITIES_API}/${id}/`,
        data
      );
      return response.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.userCapabilities.all });
    },
  });
}
